/** ----公共方法----*/
import Tools from '@/core/tools'
import dictSwitch from '@/core/dictSwitch'
const THREE = window.THREE
export default {
  // 获取url中的特定query
  getUrlQuery(key) {
    const url = window.location.href
    const queryStr = url.includes('?') ? url.split('?')[1] : ''
    if (queryStr) {
      const variables = queryStr.split('&')
      const len = variables.length
      for (let i = 0; i < len; i++) {
        const item = variables[i].split('=')
        if (item[0] === key) {
          return item[1]
        }
      }
    } else {
      return ''
    }
  },
  // 加密
  encrypt(s) {
    return s
      .split('')
      .map((c) => {
        const code = c.charCodeAt(0)
        return code >= 65 && code <= 90
          ? String.fromCharCode(code + 32)
          : code >= 97 && code <= 122
            ? String.fromCharCode(code - 32)
            : c
      })
      .join('')
  },
  // 获取日期的年月日字符串
  getFullDate(date) {
    const dateObj = new Date(date)
    return `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}-${dateObj.getDate()}`
  },

  // 根据children id 寻找父级链路
  getPathByChild(source, childId, rootId = null, ids = [], names = []) {
    const child = source.find((x) => { return x.id === childId })
    if (!child) {
      return { ids: [], names: [] }
    }
    ids.unshift(child.id)
    names.unshift(child.name)

    if (child.parentId && child.parentId !== rootId) {
      const parent = source.find((p) => { return p.id === child.parentId })
      return this.getPathByChild(source, parent.id, rootId, ids, names)
    }
    return { ids, names }
  },

  // 根据children code 寻找父级链路
  getPathByChildCode(source, childCode, rootCode = null, codes = [], names = []) {
    const child = source.find((x) => { return x.code === childCode })
    if (!child) {
      return { codes: [], names: [] }
    }
    codes.unshift(child.code)
    names.unshift(child.name)

    if (child.parentCode && child.parentCode !== rootCode) {
      const parent = source.find((p) => { return p.code === child.parentCode })
      return this.getPathByChildCode(source, parent.code, rootCode, codes, names)
    }
    return { codes, names }
  },

  // 递归去除children为空的数组
  getTreeData(data) {
    // 循环遍历json数据
    for (let i = 0; i < data.length; i++) {
      if (data[i].children.length < 1) {
        // children若为空数组，则将children设为undefined
        data[i].children = undefined
        data[i].isLeaf = true
      } else {
        // children若不为空数组，则继续 递归调用 本方法
        this.getTreeData(data[i].children)
      }
    }
    return data
  },
  // 将扁平数组转为树形结构
  listToTree(arr, diffOrNot, key = 'code', rootParentCode) { // diffOrNot 是否区分引用
    const list = Tools.deepCopy(arr).sort(Tools.compare('weight'))
    const parentNodeKey = key === 'code' ? 'parentCode' : 'parentId'
    const map = {}; let node; const tree = []; let i
    for (i = 0; i < list.length; i++) {
      map[list[i][key]] = list[i]
      list[i].children = []
      if (diffOrNot) {
        list[i].unquoteChildren = []
      }
    }
    for (i = 0; i < list.length; i += 1) {
      node = list[i]
      if ((node[parentNodeKey] || node[parentNodeKey] === 0) && node[parentNodeKey] !== rootParentCode) {
        if (diffOrNot) {
          node.status
            ? map[node[parentNodeKey]].children.push(node)
            : map[node[parentNodeKey]].unquoteChildren.push(node)
        } else {
          if (map[node[parentNodeKey]]) {
            map[node[parentNodeKey]].children.push(node)
          }
        }
      } else {
        tree.push(node)
      }
    }
    return this.getTreeData(tree)
  },
  // 将树形结构转为扁平数组
  treeToList(data, diffOrNot) { // diffOrNot 表示tree中是否区分引用
    const tree = Tools.deepCopy(data)
    let queen = []
    const result = []
    queen = queen.concat(tree)
    while (queen.length) {
      const first = queen.shift()
      if (diffOrNot) {
        let childFlat
        if (first.children) {
          childFlat = [...first.children, ...first.unquoteChildren].sort(Tools.compare('weight'))
        } else {
          childFlat = [...first.unquoteChildren].sort(Tools.compare('weight'))
        }
        first.children = childFlat
        delete first.unquoteChildren
      }
      if (first.children) {
        queen = queen.concat(first.children)
        delete first.children
      }
      result.push(first)
    }
    return result
  },
  // threejs所需方法
  genUuid() {
    var s = []
    var hexDigits = '0123456789abcdef'
    for (var i = 0; i < 36; i++) {
      s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
    }
    s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
    s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
    s[8] = s[13] = s[18] = s[23] = '-'
    var uuid = s.join('')
    return uuid.toUpperCase()
  },

  rgbaToHex(red, green, blue) {
    const color = new THREE.Color()
    color.setRGB(red / 255, green / 255, blue / 255)
    return color.getHex()
  },

  async decodeImage(url) {
    var p = new Promise((resolve, reject) => {
      var loader = new window.CryptoResourceLoader()
      loader.loadURL(url, resolve, reject)
    })
    const data = await p
    return data
  },

  async blobToDataURL(blob) {
    var p = new Promise((resolve) => {
      // var p = new Promise(function (resolve, reject) {
      const a = new FileReader()
      a.onload = (e) => { resolve(e.target.result) }
      a.readAsDataURL(blob)
    })
    const data = await p
    return data
  },

  arrGroup(array, subGroupLength) {
    let index = 0
    const newArray = []
    while (index < array.length) {
      newArray.push(array.slice(index, index += subGroupLength))
    }
    return newArray
  },

  // 拆解版本信息，返回主版本信息
  getMainVersion(version) {
    if (!version) { return '' }
    const arr = version.split('.').slice(0, 2)
    return arr.join('.')
  },

  // 比较版本大小
  isHigherVersion(targetVersion, sourceVersion) {
    if (!targetVersion || !sourceVersion) {
      return false
    }
    const targetArr = targetVersion ? String(targetVersion).split('.') : []
    const sourceArr = sourceVersion ? String(sourceVersion).split('.') : []
    for (let i = 0; i < targetArr.length; i++) {
      if ((sourceArr[i] || sourceArr[i] === 0) && targetArr[i] - sourceArr[i] > 0) {
        return true
      }
    }
    return false
  },

  // 比较版本大小:
  // targetVersion大于sourceVersion：返回1
  // targetVersion小于sourceVersion：返回-1
  // targetVersion等于sourceVersion：返回0
  compareVersion(targetVersion, sourceVersion) {
    // 1. 点分版本号
    const targetArr = targetVersion ? targetVersion.split('.') : []
    const sourceArr = sourceVersion ? sourceVersion.split('.') : []

    // 2. 数组长度对齐
    const maxLength = Math.max(targetArr.length, sourceArr.length)
    while (targetArr.length < maxLength) {
      targetArr.push(0)
    }
    while (sourceArr.length < maxLength) {
      sourceArr.push(0)
    }

    // 3. 从前到后，比较每一部分
    for (let i = 0; i < maxLength; i++) {
      const targetPart = targetArr[i] || 0
      const sourcePart = sourceArr[i] || 0
      if (targetPart > sourcePart) {
        return 1
      }
      if (targetPart < sourcePart) {
        return -1
      }
    }
    return 0
  },

  // 根据gac文件的解析结果，判断图例的专业和视图信息
  getGacLegendType(gacJson) {
    if (!gacJson) {
      return { validLegendType: false }
    }
    const familyParamsDefinitionsObj = gacJson.FamilyParameterDefinitions || {}
    const FamilyTypeObj = gacJson.FamilyType || {}

    const paramsDefinitions = familyParamsDefinitionsObj.Param || []
    const paramsValue = FamilyTypeObj.Param || []
    const typeArr = paramsDefinitions.filter((pv) => { return pv.Guid === '{2babba5c-ba50-4fae-840c-6adefe2377b7}' || pv.Guid === '{d8cb10a5-95aa-4e6c-ac3a-791a150a6950}' })
    // const typeArr = paramsValue.filter((pv) => { return pv.ParamName === '通用图例类型' || pv.ParamName === '电气图例类型' })
    if (typeArr.length !== 1) {
      // 没有图例类型或者有多个值，都报错
      return { validLegendType: false }
    }
    const typeInfo = typeArr[0]
    const typeDefinitions = paramsValue.find((pd) => pd.ParamName === typeInfo.Name)
    if (!typeDefinitions || !typeInfo.EnumList) {
      return { validLegendType: false }
    }
    let options = typeInfo.EnumList.Item || []
    // typeDefinitions.EnumList.Item如果只有一个值，解析出来的是个对象，所以需要兼容下对象的情况
    if (!Array.isArray(options)) { options = [options] }
    const typeValue = options.find((op) => op.__text === typeDefinitions.ParamValue)
    if (!typeValue || !typeValue._Display) {
      return { validLegendType: false }
    }
    const discipline = typeInfo.Guid === '{d8cb10a5-95aa-4e6c-ac3a-791a150a6950}' ? 'ELECTRIC' : 'COMMON'
    const placeholderType = typeValue.__text === '0' ? 'PLAN'
      : typeValue.__text !== '0' && typeValue.__text !== '2' ? 'ELEVATION'
        : 'PROFILE'
    return {
      validLegendType: true,
      discipline,
      disciplineStr: dictSwitch.switchPlaceholderMajor(discipline),
      placeholderType,
      placeholderTypeStr: dictSwitch.switchPlaceholderType(placeholderType),
    }
  },

  // 文件名去掉后缀名
  getFileName(fullName) {
    if (!fullName) { return '' }
    const arr = fullName.split('.').slice(0, -1)
    return arr.join('.')
  },

  // xlsx文件中，将对应的中文key转化成自定义的英文
  transitionKey(origin, relationship) {
    const list = []
    origin.forEach((item) => {
      const obj = { __rowNum__: item.__rowNum__ }
      Object.keys(item).forEach((k) => {
        if (relationship[k]) {
          obj[relationship[k]] = item[k]
        } else {
          obj[k] = item[k]
        }
      })
      list.push(obj)
    })
    return list
  },

  // 四舍五入保留六位小数
  formatValue(value) {
    if (value) {
      if (typeof value === 'number') {
        value = value.toString()
      }
      const values = value.split('.')
      if (values.length > 1 && values[1].length > 2) {
        return Number(value).toFixed(2)
      }
    }
    return value
  },

  /**
 * 弧度转角度
 */
  rad2deg(rad) {
    if (rad || rad === 0) {
      const deg = (180 / Math.PI * Number(rad)).toFixed(2)
      return Number(deg)
    }
  },
  /**
 * 角度转弧度
 */
  deg2rad(deg) {
    if (deg || deg === 0) {
      const rad = (Math.PI / 180 * Number(deg))
      return Number(rad)
    }
  },
  /**
   * 排序处理方法**/
  handleTableSort(val, matchObj, defaultSort = { sortField: 'CREATE_TIME', orderType: 'DESC' }) {
    if (!val || !val.order) {
      return defaultSort
    } else {
      const sortField = matchObj[val.prop] || defaultSort.sortField
      return {
        sortField,
        orderType: val.order === 'ascending' ? 'ASC' : 'DESC'
      }
    }
  },
  /**
   * 上传文件前，校验文件格式及大小**/
  uploadCheckFile(file, allowTypeStr) {
    const allowTypes = allowTypeStr.split(',')
    const arr = file.name.split('.')
    const type = '.' + arr[arr.length - 1].toLowerCase()
    const isType = allowTypes.indexOf(type) > -1
    const size = file.size
    if (!size) {
      this.$message.error(`文件内容为空，已自动删除不符合的文件`)
      return false
    }
    if (!isType) {
      this.$message.error(`文件格式有误，已自动删除不符合的文件`)
      return false
    }
    return true
  },
  /** 根据子模块code，提取出平台code。子模块code规则：V_页面code_平台code **/
  splitPlatform(code) {
    if (code) {
      const arr = code.split('_')
      // 去掉前两个元素，只保留平台code
      const platformArr = arr.slice(2)
      return platformArr.join('_')
    } else {
      return ''
    }
  },
  // 企业库分类管理将扁平数组转为树形结构
  classifyAuthListToTree(arr, key = 'id', parentKey = 'parentId') {
    const getDeepId = function (node, deepId, nodeMap) {
      let tempId = deepId
      if (node[parentKey]) {
        if (nodeMap[node[parentKey]]) {
          tempId = `${nodeMap[node[parentKey]][key]}_${tempId}`
          tempId = getDeepId(nodeMap[node[parentKey]], tempId, nodeMap)
        } else {
          console.log(`企业库分类管理将扁平数组存在冗余节点:${node[parentKey]}`)
        }
      }
      return tempId.toString()
    }

    const list = Tools.deepCopy(arr)
    const map = {}
    const tree = []

    for (let i = 0; i < list.length; i++) {
      map[list[i][key]] = list[i]
      list[i].editName = false
      list[i].children = []
    }

    for (let j = 0; j < list.length; j++) {
      list[j].deepId = getDeepId(list[j], list[j][key], map)
      if (list[j][parentKey]) {
        if (map[list[j][parentKey]]) {
          map[list[j][parentKey]].children.push(list[j])
        } else {
          console.log(`企业库分类管理将扁平数组存在冗余节点:${list[j][parentKey]}`)
        }
      } else {
        tree.push(list[j])
      }
    }

    return { tree, list }
  },
  // 将树形结构转为扁平数组
  treeToList_v2(data, diffOrNot) { // diffOrNot 表示tree中是否区分引用
    const tree = Tools.deepCopy(data)
    let queen = []
    const result = []
    queen = queen.concat(tree)
    while (queen.length) {
      const first = queen.shift()
      if (diffOrNot) {
        let childFlat
        if (first.children) {
          childFlat = [...first.children, ...first.unquoteChildren].sort(Tools.compare('weight'))
        } else {
          childFlat = [...first.unquoteChildren].sort(Tools.compare('weight'))
        }
        first.children = childFlat
        delete first.unquoteChildren
      }
      if (first.children) {
        queen = queen.concat(first.children)
        delete first.children
      }
      result.push(first)
    }
    return result
  },
  // 字符串截取
  truncateString(str, maxLength) {
    if (str.length <= maxLength) {
      return str
    }
    return str.substring(0, maxLength) + '...'
  },

  findClosestObjectByTime(arr, timePropName) {
    // 获取当前时间的时间戳
    const now = Date.now()

    // 初始化一个对象用于存储距离当前时间最近的元素和对应的时间差
    let closestObj = null
    let minDiff = Infinity

    // 遍历数组
    arr.forEach((obj) => {
      // 尝试将时间属性转换为时间戳
      const timeStr = obj[timePropName]
      const objTime = new Date(timeStr).getTime()

      // 计算时间差
      const diff = Math.abs(now - objTime)

      // 如果找到更近的时间差，则更新closestObj和minDiff
      if (diff < minDiff) {
        closestObj = obj
        minDiff = diff
      }
    })

    // 返回找到的最接近的对象
    return closestObj
  }
}
